'use client'

import { createContext, useContext } from 'react'

interface ThemeContextValue {
  primaryColor: string
}

const ThemeContext = createContext<ThemeContextValue>({ primaryColor: '#000000' })

function useWidgetTheme() {
  return useContext(ThemeContext)
}

export { ThemeContext, useWidgetTheme }
